import {Button} from '@components/ui/button'
import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {useState} from 'react'
import {ScheduleModal} from '@features/assignment/components/schedule-modal'
import {Assignment, ServiceType} from '@features/assignment/types.ts'
import {ClockIcon} from '@components/ui/icon'
import {formatLocaleDate} from '@/dates.ts'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'
import {cn} from '@utilities/helpers'

export const AcceptedHostNotReadyDescription = ({
    assignment,
    serviceType
}: {
    assignment: Assignment
    serviceType: ServiceType
}) => {
    const {t} = useTranslation()
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)

    return (
        <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
            <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                    {t('assignment:descriptions:accepted_host_not_ready:title', {
                        date: assignment.host_not_ready_at ? formatLocaleDate(assignment.host_not_ready_at, 'PPP') : '-'
                    })}
                </h3>
                {assignment.host_ready_at ? (
                    <p className={cn(ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME, 'flex items-center gap-1')}>
                        <ClockIcon size={20} />
                        <span>
                            <Trans
                                i18nKey="assignment:descriptions:accepted_host_not_ready:paragraph_date"
                                values={{
                                    date: assignment.host_ready_at
                                        ? formatLocaleDate(assignment.host_ready_at, 'PPPPp')
                                        : '-'
                                }}
                                components={{strong: <strong />}}
                            />
                        </span>
                    </p>
                ) : (
                    t('assignment:descriptions:accepted_host_not_ready:paragraph', {
                        date: assignment.reminder_at ? formatLocaleDate(assignment.reminder_at, 'PPP') : '-'
                    })
                )}
            </div>
            <Button onClick={() => setIsScheduleModalOpen(true)}>{t('assignment:descriptions:schedule')}</Button>
            {isScheduleModalOpen && (
                <ScheduleModal
                    assignment={assignment}
                    serviceType={serviceType}
                    onClose={() => setIsScheduleModalOpen(false)}
                />
            )}
        </div>
    )
}
